module.exports = __webpack_public_path__ + "static/media/verification_EN.712cd7ba.jpg";